import { __decorate } from "tslib";
import { Component, Vue, } from "vue-property-decorator";
// import { objAny, objStr, objNumber } from "../../common/common-interface";
let PiHome = class PiHome extends Vue {
    constructor() {
        super(...arguments);
        this.test = "light";
    }
};
PiHome = __decorate([
    Component
], PiHome);
export default PiHome;
